import type { NavigateFunction } from 'react-router-dom'
import { USERLIST_FILTER_SESSION_KEY } from './userManagementNavigation.constants'
import type { AngularUserManagementHandoff } from './userManagementNavigation.types'

export { USER_MANAGEMENT_MODULE_KEY, USERLIST_FILTER_SESSION_KEY } from './userManagementNavigation.constants'
export type { AngularUserManagementHandoff } from './userManagementNavigation.types'

export function getUserManagementEditUrl(userId: string | number): string {
  return `/user-management/edit/${userId}`
}

/** Company edit / company details `usermanagement()`: `{ company_id, company_name }`. */
export function setSessionUserListFilterCompany(
  companyId: string | number | undefined | null,
  companyName?: string | null,
): void {
  if (companyId == null || String(companyId).trim() === "") return
  try {
    sessionStorage.setItem(
      USERLIST_FILTER_SESSION_KEY,
      JSON.stringify({
        company_id: companyId,
        company_name: String(companyName ?? "").trim(),
      }),
    )
  } catch {
    /* quota / private mode */
  }
}

/** Property edit `usermanagement()`: property + company context for the user list. */
export function setSessionUserListFilterProperty(params: {
  propertyId: string | number
  propertyName?: string | null
  companyId?: string | number | null
  companyName?: string | null
}): void {
  const { propertyId, propertyName, companyId, companyName } = params
  if (propertyId == null || String(propertyId).trim() === "") return
  try {
    sessionStorage.setItem(
      USERLIST_FILTER_SESSION_KEY,
      JSON.stringify({
        property_id: propertyId,
        property_name: String(propertyName ?? "").trim(),
        company_id: companyId ?? "",
        company_name: String(companyName ?? "").trim(),
      }),
    )
  } catch {
    /* quota / private mode */
  }
}

/**
 * Opens the User Management list. When `handoff` is set, seeds `userlist_filter`
 * in sessionStorage (the list reads the same key).
 */
export function navigateToUserManagementList(
  navigate: NavigateFunction,
  handoff?: AngularUserManagementHandoff,
): void {
  if (handoff?.scope === "company") {
    setSessionUserListFilterCompany(handoff.companyId, handoff.companyName)
  } else if (handoff?.scope === "property") {
    setSessionUserListFilterProperty({
      propertyId: handoff.propertyId,
      propertyName: handoff.propertyName,
      companyId: handoff.companyId,
      companyName: handoff.companyName,
    })
  }
  navigate("/user-management")
}

export function navigateToUserManagementEdit(
  navigate: NavigateFunction,
  userId: string | number,
): void {
  navigate(`/user-management/edit/${userId}`)
}
